import PropTypes from 'prop-types';
import React from 'react';
import NumberFormat from 'react-number-format';
import { roundToDecimals } from '../utils';

Number.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    fractionDigits: PropTypes.number,
    noThousandSeparator: PropTypes.bool,
};

Number.defaultProps = {
    value: 0,
    fractionDigits: null,
    noThousandSeparator: false,
};

function Number(props) {
    const {
        value,
        fractionDigits,
        noThousandSeparator,
    } = props;
    return (
        <NumberFormat
            value={(fractionDigits !== null && value !== null) ? roundToDecimals(parseFloat(String(value)), fractionDigits) : value}
            displayType="text"
            decimalScale={fractionDigits == null ? undefined : fractionDigits}
            fixedDecimalScale={fractionDigits > 0}
            renderText={(formattedValue) => formattedValue}
            thousandSeparator={noThousandSeparator ? undefined : ' '}
            isNumericString
        />
    );
}

export default Number;
